export const createBsUtilMsgItem = (me, market, selection) => {
    return {
        selectionId: selection.id,
        marketId: market.id,
        eventId: me.id,
        type: "Regular",
        sportId: market.sportId,
        selectionPresentationInfo: {
            betslipLines: [
                [selection.betslipLine],
                market.betslipLine,
                me.betslipLine,
                ""
            ],
            group: selection.group,
            title: selection.title || "",
            points: selection.points || 0,
            isLive: market.isLive,
            isDisabled: selection.isDisabled,
            outcomeType: selection.outcomeType || "",
            tags: selection.tags,
            status: selection.status,
            participantMapping: selection.participantMapping || "",
            trueOdds: selection.trueOdds,
            displayOdds: selection.odds,
            isSP: false // not supported yet
            // eachWayTrueOdds: // not supported yet
        }
    };
};
//# sourceMappingURL=createBsUtilMsgItem.js.map